import { I18N_DOMAIN } from '../settings';
import PrePublishHeader from './prepublish/PrePublishHeader';

const { compose } = wp.compose;
const { withDispatch, withSelect } = wp.data;
const { Component } = wp.element;
const { __, sprintf } = wp.i18n;

class EpisodeNumber extends Component {
	isBlocked = () => {
		const { episodeNumber } = this.props;
		if (episodeNumber === '') {
			return true;
		}
		return false;
	};

	render() {
		const { updatedStatus } = this.props;
		let title = 'published';
		if (updatedStatus === 'updated' || updatedStatus === 'publish') {
			title = 'updated';
		}

		return (
			<>
				<PrePublishHeader.Approval name="ib-podcast-number" display={this.isBlocked} type="blocker">
					<p>
						{sprintf(__('A Podcast cannot be %s without an Episode Number.', I18N_DOMAIN), title)}
					</p>
				</PrePublishHeader.Approval>
			</>
		);
	}
}

export default compose([
	withSelect(select => {
		const { getEditedPostAttribute } = select('core/editor');
		const { episode_number: episodeNumber } = getEditedPostAttribute('meta');
		const updatedStatus = getEditedPostAttribute('status');

		return {
			episodeNumber,
			updatedStatus,
		};
	}),
	withDispatch(dispatch => ({
		editPost: dispatch('core/editor').editPost,
	})),
])(EpisodeNumber);
